/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react'
import classNames from 'classnames'
import {bool, string, func} from 'prop-types'

const HelperLink = ({isVisible, caption, onClick, isDisabled, isEmphasised, uniqueID, href}) => (isVisible && (
  <p className='linkWrapper'>
    <a
      onClick={onClick}
      className={classNames({disabled: isDisabled, emphasis: isEmphasised})}
      role='button'
      tabIndex={0}
      data-testid={uniqueID}
      href={href}
    >
      {caption}
    </a>
  </p>
))

HelperLink.propTypes = {
  isVisible: bool,
  isDisabled: bool,
  isEmphasised: bool,
  caption: string.isRequired,
  onClick: func,
  uniqueID: string,
  href: string
}

export default HelperLink
